import { useI18n } from 'vue-i18n'
import type { PL } from '@/types'

export const useSwdI18n = () => {
  const swdI18nObject = useI18n<{ message: PL }>()

  return swdI18nObject
}
